import React, { useEffect, useState } from 'react';
import { string, func, array, bool } from 'prop-types';
import { Loading, Modal, TableCustom } from '../../common';
import { useEntidad } from '../../hooks/useEntidad';
import { ALERT_TYPE, ShowToastMessage } from '@laramie/ui';
import '@laramie/ui/dist/components/controls/EntidadesModal/index.css';

import { CloneObject } from '../../../utils/helpers';
import {TIPS} from "../../../consts/tips";


const EntidadesModal = (props) => {

  //hooks
  const [state, setState] = useState({
      showMessage: false,
      loading: false,
      list: []
  });

  const [getListEntidad,] = useEntidad({
    entidades: props.data ? [] : [props.entidad],
    onLoaded: (entidades, isSuccess, error) => {
        if (isSuccess) {
          const listFilter = getListEntidad(props.entidad).filter(props.filter);
          setState(prevState => {
            return {...prevState, loading: false, list: listFilter};
          });
        }
        else {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
        }
    },
    memo: (props.memo) ? {
      key: props.entidad,
      timeout: 0
    }: null
  });

  useEffect(() => {
    if (props.data) {
      const listFilter = props.data.filter(props.filter);
      setState(prevState => {
        return {...prevState, loading: false, list: listFilter};
      });
    }
  }, [props.data]);

  const cellS = (props) =>    <div className='action'>
                                  <div onClick={ (event) => handleClickSelect(props.value) } className="link">
                                      <span className="material-symbols-outlined" title="Seleccionar">west</span>
                                  </div>
                              </div>

  const rowSelect = { Header: '', Cell: cellS, id:'select', accessor: 'id', width: '5%', disableGlobalFilter: true, disableSortBy: true };
  const tableColumns = [rowSelect].concat(props.columns);

  //handles
  const handleClickSelect = (id) => {
    const row = state.list.find(f => f.id === id);
    props.onConfirm(id, CloneObject(row));
  }

  const handleClicWithoutSelection = () => {
    props.onConfirm(0, null);
  }


  return (
    <div className='entidad-modal'>

      <Loading visible={state.loading}></Loading>

      <Modal
        size="lg"
        title={props.title}
        tipName={props.tipName || TIPS.NAME.MODALS.ENTIDADES_MODAL}
        onEscape={() => props.onDismiss()}
        body={(
              <TableCustom
                  showFilterGlobal={true}
                  className={'TableCustomBase'}
                  columns={tableColumns}
                  data={state.list}
                  onClickRow={({ original }) => props.onConfirm(original.id, CloneObject(original))}
              />
        )}
        footer={(
              <div className='footer-action-container'>
                {props.showWithoutSelection &&
                <button className="btn btn-outline-primary float-end" data-dismiss="modal" onClick={ (event) => handleClicWithoutSelection() }>Sin selección</button>
                }
                <button className="btn back-button float-start" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Volver</button>
              </div>
        )}
      />

    </div>
  );
}

EntidadesModal.propTypes = {
  title: string.isRequired,
  entidad: string.isRequired,
  onConfirm: func.isRequired,
  onDismiss: func.isRequired,
  filter: func,
  columns: array.isRequired,
  data: array,
  showWithoutSelection: bool,
  memo: bool,
  tipName: string
};

EntidadesModal.defaultProps = {
  filter: x => true,
  data: null,
  showWithoutSelection: true,
  memo: true,
  tipName: ''
};

export default EntidadesModal;
